import React, { useEffect, useState } from "react";
import { collection, getDocs, orderBy, query } from "firebase/firestore";
import { db } from "../utils/firebaseConfig";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination, Navigation, EffectFade } from "swiper";

import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import "swiper/css/effect-fade";
import "../Styles/PhotoCarousel.css";

const PhotoCarousel = () => {
  const [photos, setPhotos] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchPhotos = async () => {
      try {
        const q = query(
          collection(db, "carouselPhotos"),
          orderBy("createdAt", "desc")
        );
        const snap = await getDocs(q);
        const docs = [];
        snap.forEach((d) => docs.push({ id: d.id, ...d.data() }));
        setPhotos(docs);
      } catch (err) {
        console.log("Error loading carousel photos:", err);
      } finally {
        setLoading(false);
      }
    };
    fetchPhotos();
  }, []);

  if (loading) return null;
  if (!photos.length) return null;

  return (
    <div className="photo_carousel">
      <Swiper
        modules={[Autoplay, Pagination, Navigation, EffectFade]}
        effect="fade"
        fadeEffect={{ crossFade: true }}
        autoplay={{ delay: 4500, disableOnInteraction: false }}
        loop={photos.length > 1}
        pagination={{ clickable: true }}
        navigation={photos.length > 1}
        slidesPerView={1}
      >
        {photos.map((p) => (
          <SwiperSlide key={p.id}>
            <div className="photo_carousel_slide">
              <img src={p.url} alt={p.caption || "old house"} loading="lazy" />
              {p.caption && (
                <div className="photo_carousel_caption">{p.caption}</div>
              )}
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default PhotoCarousel;
